export enum ReturnMetricEnum {
    SimpleReturn = 'sr',
    TimeWeightedReturn = 'twr',
    MoneyWeightedReturn = 'mwr',
}
